import React from 'react';

export function Privacy() {
    return (
        <div className="min-h-screen bg-background py-16 px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto prose dark:prose-invert">
                <h1 className="text-3xl font-bold text-foreground mb-8">Privacy Policy</h1>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-foreground mb-4">1. Information We Collect</h2>
                    <p className="text-muted-foreground mb-4">
                        We collect information you provide directly to us, such as when you create or modify your account, request on-demand services, contact customer support, or otherwise communicate with us. This information may include: name, email, phone number, postal address, profile picture, payment method, items requested (for delivery services), delivery notes, and other information you choose to provide.
                    </p>
                </section>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-foreground mb-4">2. How We Use Your Information</h2>
                    <p className="text-muted-foreground mb-4">
                        We use the information we collect to provide, maintain, and improve our services, such as to:
                    </p>
                    <ul className="list-disc pl-5 text-muted-foreground space-y-2">
                        <li>Process uploaded images for background removal.</li>
                        <li>Send you technical notices, updates, security alerts and support and administrative messages.</li>
                        <li>Respond to your comments, questions and requests and provide customer service.</li>
                    </ul>
                </section>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-foreground mb-4">3. Data Security</h2>
                    <p className="text-muted-foreground mb-4">
                        We take reasonable measures to help protect information about you from loss, theft, misuse and unauthorized access, disclosure, alteration and destruction.
                    </p>
                </section>

                <div className="pt-8 border-t border-border">
                    <p className="text-sm text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>
                </div>
            </div>
        </div>
    );
}
